// This file was auto-generated by Fern from our API Definition.
import * as FernIr from "../../../../../index.mjs";
export const GeneratorOutputConfig = {
    publish: (value) => {
        return {
            value: value,
            type: "publish",
            _visit: function (visitor) {
                return FernIr.dynamic.GeneratorOutputConfig._visit(this, visitor);
            },
        };
    },
    local: () => {
        return {
            type: "local",
            _visit: function (visitor) {
                return FernIr.dynamic.GeneratorOutputConfig._visit(this, visitor);
            },
        };
    },
    _visit: (value, visitor) => {
        switch (value.type) {
            case "publish":
                return visitor.publish(value.value);
            case "local":
                return visitor.local();
            default:
                return visitor._other(value);
        }
    },
};
